import { z } from "zod";

import { KernelSize } from "../kernelConfigTypes.js";
import { typedObjectValues } from "../utils/index.js";
import { OrgId } from "../idTypeBrands.js";

import { zBrandedRecord } from "../zod/utils.js";
export const PrewarmedSizeCounts = zBrandedRecord<KernelSize, z.ZodNumber>(
  z.number(),
);
export type PrewarmedSizeCounts = z.infer<typeof PrewarmedSizeCounts>;

export const PrewarmedDefaultInfo = z.object({
  numberOfPrewarmedImages: z.number(),
  missingSizePrewarmedPodCount: z.number(),
  prewarmSizes: PrewarmedSizeCounts,
});

export type PrewarmedDefaultInfo = z.infer<typeof PrewarmedDefaultInfo>;

export type CustomKernelJobConfig = {
  k8sNamespace: string;
  org: OrgId;
  jobName: string;
  baseImage: string;
  imageVersionId: string;
  destinationRepo: string;
  destinationTag: string;
  restartPolicy: "Always" | "OnFailure" | "Never";
  backOffLimit: number;
  kanikoImage:
    | string
    | "ghcr.io/kaniko-build/dist/chainguard-forks-kaniko/executor:v1.25.12";
  hexAssetVersion: string;
  /** CI-only knobs for running kaniko against local registry/s3 stand-ins */
  testOptions?: {
    extraKanikoArgs: string[];
    extraEnv: { name: string; value: string }[];
    resources?: {
      memoryRequest: string;
      memoryLimit: string;
      cpuLimit: string;
    };
  };
};

export function getZeroedKernelSizes(): PrewarmedSizeCounts {
  return {
    xsmall: 0,
    small: 0,
    medium: 0,
    large: 0,
    xlarge: 0,
    "2xlarge": 0,
    "4xlarge": 0,
    l4: 0,
    a10g: 0,
  };
}

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export const NoPrewarmedImages = PrewarmedDefaultInfo.parse({
  numberOfPrewarmedImages: 0,
  missingSizePrewarmedPodCount: 0,
  prewarmSizes: getZeroedKernelSizes(),
});

export function isPrewarmedInternal(
  prewarmedSizes: PrewarmedSizeCounts,
): boolean {
  return typedObjectValues(prewarmedSizes).some(
    (prewarmedNumber) => prewarmedNumber > 0,
  );
}
